module.exports = __webpack_public_path__ + "img/IMG_7947.9904765e.jpg";